import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ILearningType } from '../models/learning-type.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class LearningService {
  endpoint = '/api/Learning/';
  private learningTypes$: Observable<ILearningType[]> | null = null;

  constructor(private http: HttpClient) { }

  getLearningTypes(forceRefresh = false): Observable<ILearningType[]> {
    if (!this.learningTypes$ || forceRefresh) {
      const url = this.endpoint + 'GetLearningTypes';
      this.learningTypes$ = this.http.get<ILearningType[]>(url).pipe(
        shareReplay(1),
        catchError((error) => {
          this.learningTypes$ = null;
          throw error;
        })
      );
    }

    return this.learningTypes$;
  }

  seedDatabase(): Observable<boolean> {
    const endpoint = `/api/Learning/SeedDatabase`;

    return this.http.post<boolean>(endpoint, '', httpOptions);
  }
}
